<script lang="ts">
	import Main from '../Core/main.svelte';
	import Screen from '../components/Screen.svelte';
	import { gameStart, gameState, currentLevel } from '../stores/winState';
	import LevelElement from '../Core/Elements/LevelElement.svelte';
	import { HEIGHT, WIDTH } from '../utils/constants';
	import Icon from '../components/Icon.svelte';

	$: levelNum = $currentLevel;
	$: selectedLevel = 0;

	let lastRowElement = new Array(4, 9, 14, 19, 24, 29, 34, 39, 44, 49, 54, 59, 64);
	let levels = Array(WIDTH * HEIGHT/1.5);
</script>

{#if !$gameStart}
	<div id="base">
		<div class="levels-wrapper">
			<div class="levels-title">Difficulty : easy</div>
			{#each levels as w, index}
				<LevelElement x={index} currentLevel={levelNum}>
					{#if !lastRowElement.find((element) => element === index)}
						<div class="seperator" />
					{/if}
					<button
						class="level-number {index < levelNum ? 'active-level' : ''}"
						on:click={() => {
							//$currentLevel = $currentLevel + 1;
							if (index < levelNum) {
								$gameStart = true;
								selectedLevel = index + 1;
							}
						}}
					>
						{#if index >= levelNum}
							<Icon name="lock" color={'#16123f'} />
						{:else}
							{index + 1}
						{/if}
					</button>
				</LevelElement>
			{/each}
		</div>
	</div>
{:else}
	<Main levelNum={selectedLevel} />
{/if}

<style>
	#base {
		display: block;
		margin: 0 auto;
		position: relative;
		width: 300px;
		height: 100vh;
		border-left: 10px solid #c7ddcc;
		border-right: 10px solid #c7ddcc;
		background-color: #c7ddcc;
		box-shadow: 2px 5px 16px 0px #0b325e;
	}
	.levels-title {
		position: relative;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		box-shadow: 1px 1px 11px 0px rgba(0, 0, 0, 0.75);
		height: 40px;
		margin: 0 40px;
		margin-bottom: 10px;
		line-height: 0;
		box-sizing: border-box;
		background-color: #75c9b7;
		border: 3px solid white;
		border-top: none;
		color: black;
	}

	.levels-wrapper {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.active-level {
		cursor: pointer;
		background-color: #ffe26a !important;
		border: 3px solid white !important;
		color: #e0b916 !important;
		font-weight: bolder;
		font-size: 15px;
		box-shadow: 1px 1px 11px 0px #e0b916;
	}
	.level-number {
		display: flex;
		width: 50px;
		height: 50px;
		border-radius: 25px;
		justify-content: center;
		align-items: center;
		color: #16123f;
		background-color: darkgray;
		border: 3px solid white;

		margin: 5px;
		z-index: 10;
	}
	.seperator {
		width: 20px;
		height: 2px;
		border-top: 4px solid white;
		position: absolute;
		top: 28px;
		left: 55px;
		z-index: 1;
	}
</style>
